module.exports = __webpack_public_path__ + "img/Ақмола облысы.5442c08f.png";